import Vue from 'vue'
import Vuex from 'vuex'

import home from 'store/modules/home'
import user from 'store/modules/user'
import global from 'store/modules/global'
import vehicle from 'store/modules/vehicle'
import monitor from 'store/modules/monitor'
import permission from 'store/modules/permission'
import alarm from 'store/modules/alarm'
import order from 'store/modules/order'
import rescue from 'store/modules/rescue'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	
	modules:{
		home:home,
		user:user,
		global:global,
		vehicle:vehicle,
		monitor:monitor,
		permission:permission,
		alarm:alarm,
		order:order,
		rescue:rescue
	}
})



// WEBPACK FOOTER //
// ./src/store/store.js